// extracted by mini-css-extract-plugin
module.exports = {"holder":"styles_holder__2biJQ","description":"styles_description__t5nfD","heading":"styles_heading__fyjJW","paragraph":"styles_paragraph__tmgcA","image":"styles_image__oPy3q"};